import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const UserRoleManager = () => {
  const [userRoles, setUserRoles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUserRole, setEditingUserRole] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/usr_rol"; // Base URL para SGVMAP_USR_ROLController
  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }

  // Obtener las relaciones usuario-rol
  const fetchUserRoles = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: { Authorization: getAuthorization() },
      }); // Asume un endpoint para listar todas las relaciones usuario-rol
      if (!response.ok) throw new Error("Error al obtener las relaciones usuario-rol");
      const data = await response.json();
      setUserRoles(data);
    } catch (error) {
      message.error("Error al obtener la lista de relaciones usuario-rol");
      console.error(error);
    }
  };

  // Crear o actualizar una relación usuario-rol
  const handleSaveUserRole = async (values) => {
    const method = editingUserRole ? "PUT" : "POST";
    const url = editingUserRole
      ? `${baseURL}/update`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la relación usuario-rol");

      message.success(
        editingUserRole
          ? "Relación usuario-rol actualizada correctamente"
          : "Relación usuario-rol creada correctamente"
      );
      fetchUserRoles();
      setIsModalOpen(false);
      setEditingUserRole(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la relación usuario-rol");
      console.error(error);
    }
  };

  // Eliminar una relación usuario-rol
  const handleDeleteUserRole = async (usr, idRol) => {
    try {
      const response = await fetch(`${baseURL}/delete/${usr}/${idRol}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar la relación usuario-rol");

      message.success("Relación usuario-rol eliminada correctamente");
      fetchUserRoles();
    } catch (error) {
      message.error("Error al eliminar la relación usuario-rol");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (userRole) => {
    setEditingUserRole(userRole);
    form.setFieldsValue(userRole);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleCreate = () => {
    setEditingUserRole(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchUserRoles();
  }, []);

  const columns = [
    {
      title: "Usuario",
      dataIndex: "usr",
      key: "usr",
    },
    {
      title: "ID Rol",
      dataIndex: "idRol",
      key: "idRol",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta relación?"
            onConfirm={() => handleDeleteUserRole(record.usr, record.idRol)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Relaciones Usuario-Rol</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Relación
      </Button>
      <Table columns={columns} dataSource={userRoles} rowKey={(record) => `${record.usr}-${record.idRol}`} />

      <Modal
        title={editingUserRole ? "Editar Relación Usuario-Rol" : "Crear Relación Usuario-Rol"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveUserRole}
          initialValues={{ usr: "", idRol: "" }}
        >
          <Form.Item
            name="usr"
            label="Usuario"
            rules={[{ required: true, message: "Por favor, ingrese el usuario" }]}
          >
            <Input placeholder="Usuario" />
          </Form.Item>
          <Form.Item
            name="idRol"
            label="ID Rol"
            rules={[{ required: true, message: "Por favor, ingrese el ID del rol" }]}
          >
            <Input placeholder="ID del Rol" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default UserRoleManager;
